import React from "react";

const Stars = ({rating}) => {

  const percentage = (rating / 5) * 100;
  return (
    <div className="rating">
      <span className="rating-value">({rating})</span>

      <div className="stars">
        <div className="stars-filled" style={{ width:`${percentage}%`}}>
          ★★★★★
        </div>
        <div className="stars-empty" >★★★★★</div>
      </div>
    </div>
  );
};

export default Stars;
